<template>
  <div>
    <label class="label">หัวข้อ</label>
    <el-input
      v-model="title"
      :disabled="disabled"
      class="mb-3"
      type="text"
    ></el-input>
    <div v-for="(group, index) in sections" :key="index" class="phone-group">
      <div class="text-end">
        <sc-button
          v-if="!disabled"
          variant="danger"
          class="btn-delete"
          @click="handleClickRemoveGroup(index)"
          >ลบกลุ่ม</sc-button
        >
      </div>
      <div class="row">
        <div class="col-9">
          <label class="label">ชื่อกลุ่ม</label>
          <el-input
            :value="group.title"
            :disabled="disabled"
            class="mb-3"
            type="text"
            @input="handleInputGroup(index, $event)"
          ></el-input>
        </div>
      </div>
      <div
        v-for="(input, inputIndex) in group.inputs"
        :key="`${index}-${inputIndex}`"
        class="row mb-4 input"
      >
        <div class="col-2">
          <label class="label">หัวข้อ</label>
          <el-input
            :value="input.title"
            :disabled="disabled"
            type="text"
            @input="handleInputInput(index, inputIndex, 'title', $event)"
          ></el-input>
        </div>
        <div class="col-2">
          <label class="label">ประเภท</label>
          <el-select
            :value="input.type"
            :disabled="disabled"
            @input="handleInputInput(index, inputIndex, 'type', $event)"
          >
            <el-option
              v-for="extra in extraTypeOptions"
              :key="extra.value"
              :value="extra.value"
              :label="extra.label"
              >{{ extra.label }}</el-option
            >
          </el-select>
        </div>
        <div class="col-2">
          <label class="label">Prefill</label>
          <el-select
            :value="input.prefillKey"
            :disabled="disabled"
            placeholder="ไม่ Prefill"
            clearable
            @input="handleInputInput(index, inputIndex, 'prefillKey', $event)"
          >
            <el-option
              v-for="extra in extraPrefillOptions"
              :key="extra.value"
              :value="extra.value"
              :label="extra.label"
              >{{ extra.label }}</el-option
            >
          </el-select>
        </div>
        <div class="col-1">
          <el-checkbox
            :value="input.isRequired"
            :disabled="disabled"
            class="required-checkbox"
            @input="handleInputInput(index, inputIndex, 'isRequired', $event)"
            >จำเป็นต้องกรอก</el-checkbox
          >
        </div>
        <div class="col-2 text-end">
          <sc-button
            v-if="!disabled"
            variant="danger"
            class="btn-delete"
            @click="handleClickRemoveInput(index, inputIndex)"
            >ลบ</sc-button
          >
        </div>
      </div>
      <div v-if="!disabled" class="row">
        <div class="offset-4 col-5">
          <sc-button class="w-100" @click="handleClickAddInput(index)"
            >เพิ่ม</sc-button
          >
        </div>
      </div>
    </div>
    <div v-if="!disabled" class="row mt-4">
      <div class="col-6 offset-3">
        <sc-button
          class="w-100"
          variant="secondary"
          @click="handleClickAddGroup"
          >เพิ่มกลุ่ม</sc-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import ScButton from "@/lib/components/ScButton"
import { Input, Select, Option, Checkbox } from "element-ui"

export default {
  components: {
    ScButton,
    ElInput: Input,
    "el-select": Select,
    "el-option": Option,
    "el-checkbox": Checkbox,
  },
  props: {
    value: {
      type: null,
      default: undefined,
    },
    disabled: {
      type: null,
      default: undefined,
    },
  },
  data() {
    const extraTypeOptions = [
      { value: "TEXT", label: "ข้อความ" },
      { value: "LONG_TEXT", label: "ข้อความยาว" },
      { value: "CITIZEN_CARD_IMAGE", label: "รูปบัตรประชาชน" },
    ]

    const extraPrefillOptions = [
      { value: "NAME", label: "ชื่อ" },
      { value: "MOBILE_NUMBER", label: "เบอร์โทรศัพท์" },
    ]

    return {
      extraPrefillOptions,
      extraTypeOptions,
    }
  },
  computed: {
    title: {
      get() {
        return this.value.title
      },
      set(title) {
        this.$emit("input", { ...this.value, title })
      },
    },
    sections() {
      return this.value.sections
    },
  },
  methods: {
    handleClickRemoveGroup(index) {
      this.$emit("input", {
        ...this.value,
        sections: this.value.sections.filter((_, i) => index !== i),
      })
    },
    handleClickRemoveInput(groupIndex, inputIndex) {
      this.$emit("input", {
        ...this.value,
        sections: this.value.sections.map((group, i) =>
          i === groupIndex
            ? {
                ...group,
                inputs: group.inputs.filter((_, ci) => ci !== inputIndex),
              }
            : group,
        ),
      })
    },
    handleClickAddInput(groupIndex) {
      this.$emit("input", {
        ...this.value,
        sections: this.value.sections.map((group, index) =>
          groupIndex === index
            ? {
                ...group,
                inputs: [
                  ...group.inputs,
                  {
                    title: null,
                    type: "",
                    prefillKey: null,
                    isRequired: false,
                  },
                ],
              }
            : group,
        ),
      })
    },
    handleClickAddGroup() {
      this.$emit("input", {
        ...this.value,
        sections: [...this.value.sections, { title: "", inputs: [] }],
      })
    },
    handleInputGroup(index, event) {
      this.$emit("input", {
        ...this.value,
        sections: this.value.sections.map((group, i) =>
          i === index ? { ...group, title: event } : group,
        ),
      })
    },
    handleInputInput(groupIndex, inputIndex, name, event) {
      this.$emit("input", {
        ...this.value,
        sections: this.value.sections.map((group, index) =>
          groupIndex === index
            ? {
                ...group,
                inputs: group.inputs.map((input, cIndex) =>
                  cIndex === inputIndex ? { ...input, [name]: event } : input,
                ),
              }
            : group,
        ),
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.input .btn-delete {
  margin-top: 33px;
}

.phone-group {
  padding: 30px;

  &:nth-child(2n) {
    background: #ddd;
  }
}

.required-checkbox {
  margin-top: 41px;
}
</style>
